export const ADD_TO_CART_ITEM = 'ADD_TO_CART_ITEM';
export const ADD_TO_CART_FAIL = 'ADD_TO_CART_FAIL';
export const CART_REMOVE_ITEM = 'CART_REMOVE_ITEM';
export const CART_SAVE_SHIPPING_ADDRESS = 'CART_SAVE_SHIPPING_ADDRESS';
export const CART_SAVE_PAYMENT_METHOD = 'CART_SAVE_PAYMENT_METHOD';
export const CART_RESET = 'CART_RESET';
export const CART_SAVE_NOTES= 'CART_SAVE_NOTES'

